import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { IProject, IRisk, levelNames, levelValues } from '../../../../interfaces/models/project.model';
import { ConfirmPopup, ConfirmPopupModule } from 'primeng/confirmpopup';
import { ConfirmationService } from 'primeng/api';
import { ToastrService } from 'ngx-toastr';
import { TooltipModule } from 'primeng/tooltip';
import { CommonModule, DatePipe } from '@angular/common';
import { ProjectService } from '../../../../services/project.service';
import { TagModule } from 'primeng/tag';
import { DirectionService } from '../../../../services/direction.service';
import { TranslateModule } from '@ngx-translate/core';
import { CalendarModule } from 'primeng/calendar';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { CustomAblePipe } from '../../../../pipes/able.pipe';
import { authUser } from '../../../../interfaces';
import { AuthService } from '../../../../services/auth.service';
import { DateRangeValidatorDirective } from '../../../../directives/date-range.directive';



@Component({
  selector: 'app-risks',
  standalone: true,
  imports: [
    InputTextareaModule, CalendarModule, TranslateModule,
    IconFieldModule, TagModule, CommonModule, TooltipModule,
    TableModule,
    ConfirmPopupModule,
    InputIconModule,
    FormsModule,
    ButtonModule,
    InputTextModule,
    DropdownModule,
    CustomAblePipe,
    DateRangeValidatorDirective

  ],
  templateUrl: './risks.component.html',
  styleUrl: './risks.component.scss',
  providers: [ConfirmationService, DatePipe]

})
export class RisksComponent implements OnInit {
  balanceFrozen: boolean = true;
  calcWeight() {
    if (!this.selectedRisk.likelihood || !this.selectedRisk.impact) return
    this.selectedRisk.weight = levelValues[this.selectedRisk.likelihood] * levelValues[this.selectedRisk.impact]
  }
  @ViewChild('RiskForm') RiskForm!: FormGroup;
  @ViewChild('ActualClosureDateForm') ActualClosureDateForm!: FormGroup;
  @ViewChild(ConfirmPopup) confirmPopup!: ConfirmPopup;
  _project!: IProject;
  @Input() set project(project: IProject) {
    console.log("project props", project);
    this._project = project;
  }
  get project() {
    return this._project;
  }

  set riskSearchTerm(value: string) {
    this._riskSearchTerm = value;
    this.search()
  }
  get riskSearchTerm() {
    return this._riskSearchTerm;
  }




  selectedRisk!: IRisk;
  isVisiblRiskModal = false;
  isRiskModalSubmitted = false;
  _ProjectsRelations: any;
  _riskSearchTerm = ''

  _risks = [] as IRisk[];

  filteredRisks = [] as IRisk[];

  private _actualRiskClosureDate!: Date;

  get actualRiskClosureDate(): Date {
    return this._actualRiskClosureDate;
  }
  actual_risk_DateRangeValidation = false;
  set actualRiskClosureDate(value: Date) {
    if (this.selectedRisk.risk_identification_date.getTime() > value.getTime()) {
      this.actual_risk_DateRangeValidation = true;
      this._actualRiskClosureDate = value;
    } else {
      this.selectedRisk.actual_risk_closure_date = value;
      this.actual_risk_DateRangeValidation = false;
      this._actualRiskClosureDate = value;
    }
  }








  @Input() set risks(value: IRisk[]) {
    this.filteredRisks = value;
    this._risks = value;
  }
  get risks() {
    return this._risks;
  }
  @Input() strategyId!: number;
  @Input() projectId!: number;
  @Input() set ProjectsRelations(value: any) {
    this._ProjectsRelations = value;
  }
  get ProjectsRelations() {
    return this._ProjectsRelations;
  }
  dir!: 'rtl' | 'ltr';
  user!: authUser;
  activeMenuId: number | null = null;

  constructor(
    private confirmationService: ConfirmationService,
    private toastr: ToastrService,
    private projectService: ProjectService,
    private directionService: DirectionService,
    private authService: AuthService,
    private datePipe: DatePipe,
  ) {
  }
  ngOnInit(): void {
    this.directionService.direction$.subscribe((dir) => {
      this.dir = dir;
    })
    this.authService.authBufferSub$.subscribe(user => {
      this.user = user || {} as authUser;
    })
  }

  openUpdatRiskModal(id: number) {
    this.isVisiblRiskModal = true;
    const selectedRisk = this.risks.find(x => {
      return x.id == id
    }) as IRisk;
    this.selectedRisk = structuredClone({
      ...selectedRisk,
      risk_identification_date: selectedRisk.risk_identification_date ? new Date(selectedRisk.risk_identification_date) : new Date(),
      expected_risk_closure_date: selectedRisk.expected_risk_closure_date ? new Date(selectedRisk.expected_risk_closure_date) : new Date(),
      actual_risk_closure_date: selectedRisk.actual_risk_closure_date ? new Date(selectedRisk.actual_risk_closure_date) : null
    }) as IRisk;
  }
  openCreatedRiskModal() {
    this.isVisiblRiskModal = true;
    this.selectedRisk = {} as IRisk;
  }
  confirmRiskDelete(event: Event, riskId: number) {
    const target = event.target as HTMLElement;
    this.confirmationService.confirm({
      target: target,
      message: this.dir == 'rtl' ? "هل تريد تأكيد المسح؟" : "Do you want to confirm the deletion?",
      accept: () => {
        this.projectService.deleteRisk(this.strategyId, this.projectId, riskId).subscribe(() => {
          this.toastr.success(this.dir == 'rtl' ? "تم المسح " : "Delete Successfully");
          this.risks = [...this.risks.filter(x => x.id != riskId)];
        }, () => {
          this.toastr.error(this.dir == 'rtl' ? "فشل المسح " : "Delete Failed");
        })

      },
      reject: () => {
        this.toastr.info(this.dir == 'rtl' ? "تم الالغاء" : "Canceled");
      }
    });
  }
  accept() {
    this.confirmPopup.accept();
  }
  reject() {
    this.confirmPopup.reject();
  }
  submitRisk() {
    this.isRiskModalSubmitted = true;
    if (this.RiskForm.invalid) {
      this.toastr.error(this.dir == 'rtl' ? 'Please review and complete the information' : 'يرجى مراجعة وإكمال البيانات', this.dir == 'ltr' ? 'error' : 'خطأ')
      return;
    }

    console.log("this.selectedRisk", this.selectedRisk);
    if (this.selectedRisk.id) {
      this.projectService.updateRisk(this.strategyId, this.projectId, this.selectedRisk.id,
        {
          ...this.selectedRisk,
          ... this.RiskForm.value,
          risk_identification_date: this.datePipe.transform(this.formateDate(this.selectedRisk.risk_identification_date), 'MM/dd/yyyy')?.toString(),
          expected_risk_closure_date: this.datePipe.transform(this.formateDate(this.selectedRisk.expected_risk_closure_date), 'MM/dd/yyyy')?.toString(),
          actual_risk_closure_date: this.selectedRisk.actual_risk_closure_date ? this.datePipe.transform(this.formateDate(this.selectedRisk.actual_risk_closure_date), 'MM/dd/yyyy')?.toString() : null
        }).subscribe((response) => {
          this.toastr.success(this.dir == 'rtl' ? 'نجح التحديث' : "Updated Successfully")
          const riskType = this.ProjectsRelations.riskTypes.find((x: any) => x.name_en == this.RiskForm.value['type'])
          this.risks = this.risks.map((risk) => {
            console.log(risk);
            if (risk.id == this.selectedRisk.id) {
              return {
                ...risk,
                ...this.RiskForm.value,
                weight: this.selectedRisk.weight,
                type_name: riskType.name_ar,
                likelihood_name: levelNames[this.RiskForm.value['likelihood']],
                impact_name: levelNames[this.RiskForm.value['impact']],
              }
            } else {
              return risk;
            }

          })
          this.isRiskModalSubmitted = false;
          this.isVisiblRiskModal = false;
          this.RiskForm.reset({});
          this.selectedRisk = {} as IRisk;
        })
    } else {
      this.selectedRisk = {
        ...this.selectedRisk,
        risk_identification_date: this.datePipe.transform(new Date(this.selectedRisk.risk_identification_date), 'MM/dd/yyyy')?.toString(),
        expected_risk_closure_date: this.datePipe.transform(new Date(this.selectedRisk.expected_risk_closure_date), 'MM/dd/yyyy')?.toString(),
      }
      this.projectService.createRisk(this.strategyId, this.projectId, { ... this.selectedRisk }).subscribe((response) => {
        this.isRiskModalSubmitted = false;
        this.toastr.success(this.dir == 'rtl' ? 'تم الاضافة بنجاح' : 'Added Successfully')

        const riskType = this.ProjectsRelations.riskTypes.find((x: any) => x.name_en == this.RiskForm.value['type'])
        this.risks.push({
          ...this.RiskForm.value,
          weight: this.selectedRisk.weight,
          type_name: riskType.name_ar,
          likelihood_name: levelNames[this.RiskForm.value['likelihood']],
          impact_name: levelNames[this.RiskForm.value['impact']],
          id: response['data']['entity']['id']
        })
        this.RiskForm.reset({})
        this.isVisiblRiskModal = false;
        this.selectedRisk = {} as IRisk;
      })
    }
  }

  search() {
    if (!this.riskSearchTerm || !this.riskSearchTerm.trim()) {
      this.filteredRisks = this.risks;
    }
    this.filteredRisks = this.risks.filter(({ name }) => {
      return name.includes(this.riskSearchTerm.trim())
    });

  }

  getWeightColor(weight: number) {
    // Low risk (1-8): Green
    if (weight >= 1 && weight <= 8) return '#22c55e';
    // Medium risk (9-15): Yellow
    if (weight > 8 && weight <= 15) return '#eab308';
    // High risk (16-25): Red
    if (weight > 15 && weight <= 25) return '#ef4444';
    return '#64748b'; // Default gray
  }

  isVisiblActualClosureDateModal = false;
  actual_risk_closure_date = new Date();
  isActualClosureDateSubmitted = false;
  openUpdatActualClosureDate(riskId: number) {
    const selectedRisk = this.risks.find(x => {
      return x.id == riskId
    }) as IRisk;

    this.selectedRisk = structuredClone({
      ...selectedRisk,
      risk_identification_date: selectedRisk.risk_identification_date ? new Date(selectedRisk.risk_identification_date) : new Date(),
      expected_risk_closure_date: selectedRisk.expected_risk_closure_date ? new Date(selectedRisk.expected_risk_closure_date) : new Date(),
      actual_risk_closure_date: selectedRisk.actual_risk_closure_date ? new Date(selectedRisk.actual_risk_closure_date) : null
    }) as IRisk;
    this.isVisiblActualClosureDateModal = true;

  }
  closeUpdatActualClosureDate() {
    this.isVisiblActualClosureDateModal = false;

  }
  submitActualClosureDate() {


    // Extract parts of the formatted date
    const actual_risk_closure_date = this.selectedRisk.actual_risk_closure_date ? this.formateDate(this.selectedRisk.actual_risk_closure_date) : null;


    if (this.ActualClosureDateForm.valid) {
      this.projectService.UpdateActualRiskClosureDate(this.strategyId, this.projectId, this.selectedRisk.id, actual_risk_closure_date!).subscribe((response) => {

        this.risks.map((risk) => {
          if (risk.id == this.selectedRisk.id) {
            risk.actual_risk_closure_date = this.selectedRisk.actual_risk_closure_date;
          }
          return risk;
        })

        this.toastr.success(this.dir == 'rtl' ? 'تم التحديث بنجاح' : 'Updated Successfully')
        this.closeUpdatActualClosureDate();
      })
    }
  }

  formateDate(date: Date) {
    const dateFormatter = new Intl.DateTimeFormat('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric'
    })
    return dateFormatter.format(date);
  }
  
  toggleMenu(event: Event, riskId: number) {
    event.stopPropagation();
    this.activeMenuId = this.activeMenuId === riskId ? null : riskId;
  }

  closeMenu() {
    this.activeMenuId = null;
  }

  closeAllMenus() {
    this.activeMenuId = null;
  }
}
